import request from '@/utils/request'

// 获得账单接口列表
export function getApiBillPage(query) {
  return request({
    url: '/bus/api-bill/saas-page',
    method: 'get',
    params: query
  })
}

// 获得客户所有接口及余额
export function getApiList() {
  return request({
    url: '/bus/api-bill/api-list',
    method: 'get'
  })
}

// 获得带筛选条件的接口账单总费用
export function getApiBillFeeSearched(query) {
  return request({
    url: '/bus/api-bill/searched-fee',
    method: 'get',
    params: query
  })
}

// 导出
export function exportFile(query) {
  return request({
    url: '/bus/api-bill/export-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}

// 检查客户余额预警
export function checkBalance() {
  return request({
    url: '/bus/api-bill/balance-check',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/ocpc/apiBill.js